import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Switch, Button, message , InputNumber} from "antd";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_CSC_API_BASE_URL;




const GroupModal = ({ open, onClose, editData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        name: editData.name,
        priority: editData.priority,
      });
    } else {
      form.resetFields();
    }
  }, [editData, form, open]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        name: values.name,
        priority: values.priority,
        // Internal fields
        enable_highlight: true,
        updated_by: "kamaljeet@plutos.one",
        created_at: editData?.created_at || new Date().toISOString(),
        updated_at: new Date().toISOString(),
        is_deleted: false,
      };
      if (editData) {
        await axios.put(
          `${BASE_URL}service-groups/${editData.service_group_id}`,
          payload
        );
        message.success("Group updated!");
      } else {
        await axios.post(
          `${BASE_URL}service-groups`,
          payload
        );
        message.success("Group added!");
      }
      onClose(true);
    } catch (err) {
      message.error("Failed to save group");
    }
  };

  return (
    <Modal
      open={open}
      title={editData ? "Edit Group" : "Add Group"}
      onCancel={() => onClose(false)}
      onOk={handleSubmit}
      okText={editData ? "Update" : "Add"}
      destroyOnClose
      width={400}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Group Name"
          name="name"
          rules={[{ required: true, message: "Group Name is required" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Priority"
          name="priority"
          rules={[{ required: true, message: "Priority is required" }]}
        >
          <InputNumber min={1} max={99} style={{ width: "100%" }} />
        </Form.Item>
        <Button type="primary" htmlType="submit" onClick={handleSubmit} style={{ display: "none" }}>
          Submit
        </Button>
      </Form>
    </Modal>
  );
};

export default GroupModal;